import VrrTable from './VrrTable';

export default VrrTable;
